import { truncateDecimal, type FormatDecimal } from './formatting';
import { getCurrencySymbol, type CurrencyCode } from './currency';

export type Fx = {
  readonly from: CurrencyCode;
  readonly to: CurrencyCode;
  readonly rate: string;
};

type FxGetter<T> = (fx: Fx) => T;

type FxToCurrencyString = (formatDecimal: FormatDecimal) => FxGetter<string>;

export const isLocalFx: FxGetter<boolean> = (fx) => fx.from === fx.to;

export const getFxRate: FxGetter<string> = (fx) => fx.rate;

export const fxToCurrencyString: FxToCurrencyString = (formatDecimal) => (fx) =>
  `${getCurrencySymbol(fx.to)} ${formatDecimal(truncateDecimal(fx.rate))}`;
